import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import unfRatings from "../../../../src/data/articles/cube-prospective-unfinity/unf-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  unfRatings,
  ProspectiveIntro,
  React
};